const API = {}

const modulesFiles = require.context('./apis/', true, /\.js$/)
modulesFiles.keys().forEach(filename => {
    const module = modulesFiles(filename)
    const moduleName = filename.split('/')[1]
    API[moduleName] = module.default
});

export default API